/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { ReactNode } from 'react';

// Mantine
import { Tooltip as NativeTooltip } from '@mantine/core';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Tooltip = (props: {
	onChange?: (data: any) => void;
	children?: ReactNode;
	label?: string;
	isActive?: boolean;
	position?: any;
}) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<NativeTooltip
			label={props.label}
			events={{
				hover: props.isActive ? true : false,
				focus: false,
				touch: false,
			}}
			{...props}
		>
			{props.children}
		</NativeTooltip>
	);
};
